import axios from 'axios'
import { config } from './config'
import {store} from "@/store";

const apiUrl = config.$api_url

export default {
    getToken() {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.get(apiUrl + '/admin/getToken')
            .then(response => response.data)
    },
    login(data) {
        return axios.post(apiUrl+ '/admin/login', data)
            .then(response => response.data)
    },
    sendAuthenticator(data) {
        axios.defaults.headers.common['x-access-token'] = `${data.token}`
        return axios.post(apiUrl+ '/admin/authenticator-check', data)
            .then(response => response.data)
    },
    logout() {
        return axios.get(apiUrl+'/admin/logout')
            .then(response => response.data)
    }
}